<template>
  <div class="app-menu">
    <el-menu
      :default-active="activeIndex"
      class="el-menu-head"
      mode="horizontal"
      @select="handleSelect"
      background-color="#1DD3B8"
      text-color="#fff"
      active-text-color="#fff">
      <el-menu-item
        v-for="item in menu"
        :key="item.key"
        :index="item.key">
        <img :src="item.icon"><br/>{{item.value}}
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script type="text/ecmascript-6">
import AppMenu from './AppMenu.js'
export default AppMenu
</script>

<style lang="scss">
@import "AppMenu.scss";
</style>



// WEBPACK FOOTER //
// src/components/appMenu/AppMenu.vue